import React from 'react';
import { Crown, Ticket, Gift } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

/**
 * Distingue visualmente el origen del acceso a un contenido del usuario.
 * - subscription → "Incluido en tu Premium" (dorado fuerte)
 * - purchase     → "Compra individual" (ámbar oscuro)
 * - free         → "Gratis" (gris)
 */
export function AccessBadge({ via, className = '' }) {
  if (via === 'subscription') {
    return (
      <Badge
        className={`bg-[var(--ns-gold)]/20 text-[var(--ns-gold-700)] border border-[var(--ns-gold)]/30 gap-1 ${className}`}
      >
        <Crown className="h-3 w-3" />
        Incluido en Premium
      </Badge>
    );
  }
  if (via === 'purchase') {
    return (
      <Badge
        className={`bg-[var(--ns-amber-100)] text-[var(--ns-gold-700)] border border-[var(--ns-amber-200)] gap-1 ${className}`}
      >
        <Ticket className="h-3 w-3" />
        Compra individual
      </Badge>
    );
  }
  return (
    <Badge
      className={`bg-[var(--ns-bg-2)] text-[var(--ns-text-muted)] border border-[var(--ns-border)] gap-1 ${className}`}
    >
      <Gift className="h-3 w-3" />
      Gratis
    </Badge>
  );
}

export const STATUS_BADGE_COLORS = {
  confirmed: 'bg-[var(--ns-gold)]/20 text-[var(--ns-gold-700)]',
  active: 'bg-[var(--ns-gold)]/20 text-[var(--ns-gold-700)]',
  pending: 'bg-amber-100 text-amber-800',
  past_due: 'bg-amber-100 text-amber-900',
  failed: 'bg-[var(--ns-red)]/15 text-[var(--ns-red)]',
  cancelled: 'bg-[var(--ns-bg-2)] text-[var(--ns-text-muted)]',
  refunded: 'bg-blue-100 text-blue-800',
  expired: 'bg-[var(--ns-bg-2)] text-[var(--ns-text-muted)]',
  exhausted: 'bg-amber-100 text-amber-800',
  revoked: 'bg-[var(--ns-red)]/15 text-[var(--ns-red)]',
};

export const STATUS_LABEL = {
  confirmed: 'Confirmada',
  active: 'Activa',
  pending: 'Pendiente',
  past_due: 'Pago atrasado',
  failed: 'Fallida',
  cancelled: 'Cancelada',
  refunded: 'Reembolsada',
  expired: 'Caducada',
  exhausted: 'Límite alcanzado',
  revoked: 'Revocada',
};
